import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { getContentType, removeDefaultParams } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import {
  BannerTitle,
  GridBanner,
  GridBoxContent,
  GridBoxTitle,
  GridWrapper,
  ImageBox,
  ResponsiveImage,
} from '../../StoreHomePage/BannersGrid/styled';
import { getSearchParams, hardCodedDataParentingGrid } from '../common';
import {
  fireClickedCardEvent,
  fireServedSectionEvent,
} from '../../../Utils/useFirebase';

export default React.memo(function ParentingGeneralGrid(props) {
  const { data } = props;
  const router = useRouter();
  const [gridCardSignal, setGridCardSignal] = useState({
    index: '',
    show: false,
  });
  let cardId = [];
  if (data?.items?.length > 0) {
    data?.items?.map((element, index) => {
      hardCodedDataParentingGrid?.map((items, index) => {
        if (items?.term_id == element?.tagData?.term_id) {
          element.tagData['desktopImage'] = items?.desktopUrl;
          element.tagData['mobileImage'] = items?.mobileUrl;
          element.tagData['description'] = items?.name;
        }
      });
      cardId.push(element?.tagData?.term_id);
    });
  }
  useEffect(() => {
    fireServedSectionEvent(data?.heading, cardId, getContentType());
  }, []);
  return (
    <GridWrapper>
      <BannerTitle>
        <h2>{data?.heading?.toLowerCase()}</h2>
        <h3>{data?.subHeading}</h3>
      </BannerTitle>
      <GridBanner parenting>
        {data?.items?.map((element, index) => {
          return (
            <Link
              href={{
                pathname: element?.tagData?.web_url,
                query: removeDefaultParams(router.query),
              }}
              passHref
              key={index}
              locale={false}
              onClick={(e) => {
                e.preventDefault();
                setTimeout(() => {
                  router.push(
                    element?.tagData?.web_url + getSearchParams(),
                    '',
                    {
                      locale: getRouterLocale(router),
                    },
                  );
                }, [200]);
              }}
            >
              <div
                onClick={() => {
                  fireClickedCardEvent(
                    data?.heading,
                    element?.tagData?.description,
                    getContentType(),
                    element?.tagData?.term_id,
                    null,
                    element?.tagData?.web_url,
                  );
                  setGridCardSignal({
                    index: index,
                    show: true,
                  });
                }}
                className={
                  gridCardSignal.index === index
                    ? 'column_direction gridcardopacity transitionClass'
                    : 'column_direction transitionClass'
                }
                key={index}
              >
                <ImageBox>
                  <ResponsiveImage
                    src={element?.tagData?.mobileImage}
                    srcSet={`${element?.tagData?.mobileImage}?tr=w-400,q-80 400w, ${element?.tagData?.desktopImage}?tr=w-400,q-80 400w`}
                    sizes="(max-width: 720px) 400px,400px"
                    borderRadius="4px"
                  />
                </ImageBox>
                <GridBoxTitle>{element?.tagData?.description}</GridBoxTitle>
                <GridBoxContent parenting>
                  {element?.tagData?.meta_description}
                </GridBoxContent>
              </div>
            </Link>
          );
        })}
      </GridBanner>
    </GridWrapper>
  );
});
